// @flow

import React from "react";
import { ButtonsGroup, Text } from "buba-components";
import { withRouter } from "react-router";
import sharedStyles from "../shared.scss";
import { setStatusContractDone, setStatusDeclineByCustomer } from "../../../../api/actions";
import SetStatusModalLauncher from "../SetStatusModalLauncher";
import paths from "../../../../data/paths";

type ActionsForOfferSubmittedProps = {
  id: number,
  displayErrorForStatusCode: (?number) => void,
  requestFetch: any => void,
  history: {
    push: (path: string) => void
  }
};

const ActionsForOfferSubmitted = ({
  id,
  displayErrorForStatusCode,
  requestFetch,
  history
}: ActionsForOfferSubmittedProps) => (
  <>
    <header>Bestätigung Geschäftsabschluss</header>
    <Text additionalClasses={sharedStyles.actionText}>
      Sie haben dem Kunden ein verbindliches Angebot gemacht. Sie können uns nun mitteilen, ob ein
      Geschäftsabschluss zustande gekommen ist. Über den Klick auf &quot;ABSCHLUSS ERFOLGT&quot;
      teilen Sie dies der Bürgschaftsbank mit. Anschließend wird die Anfrage für andere beteiligte
      Banken geschlossen. Sollte der Kunde Ihr Angebot ablehnen, klicken Sie bitte auf &quot;KEIN
      ABSCHLUSS ERFOLGT&quot;. Die Anfrage kann dann an andere Banken weitergeleitet werden.
    </Text>
    <ButtonsGroup>
      <SetStatusModalLauncher
        id={id}
        triggerButtonText="Abschluss Erfolgt"
        contentText="Sie sind im Begriff, einen Abschluss zum vorliegenden Angebot mitzuteilen. Sind Sie sicher?"
        displayErrorForStatusCode={displayErrorForStatusCode}
        requestFetch={requestFetch}
        setStatusAction={setStatusContractDone}
        statusName="contract done"
      />
      <SetStatusModalLauncher
        id={id}
        triggerButtonText="Kein Interesse"
        contentText="Sie Sind im Begriff, diese Anfrage zu schließen. Sind Sie sicher?"
        displayErrorForStatusCode={displayErrorForStatusCode}
        requestFetch={() =>
          new Promise(resolve => {
            history.push(paths.customerInquiriesList);
            resolve();
          })
        }
        setStatusAction={setStatusDeclineByCustomer}
        statusName="declined by customer"
      />
    </ButtonsGroup>
  </>
);

export default withRouter(ActionsForOfferSubmitted);
